export default __webpack_public_path__ + "static/media/partner-wdf.bc637835.webp";